import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withToast } from "../../contexts/toastr.context";
import { mixPanel } from "../../_config/mixpanel.config";
import { CommunityService } from "../../_service";
import I18 from "../atoms/i18";
import IconButton2 from "../icon-button-2-component";
import PremiumFeature from "../premium/premium-feature.component";

function AnalyticsLinkIcon({ user, community, communityPac, addToast }) {
  const [analyticsLink, setAnalyticsLink] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const communityId = community?.id;
  const communityRole = community?.myRole;

  useEffect(() => {
    if (communityId && communityRole === "admin") {
      setIsLoading(true);
      CommunityService.getAnalyticsLink(communityId)
        .then((response) => {
          setAnalyticsLink(response.analyticsDashboardLink);
        })
        .catch((error) => {
          addToast("Error getting analytics link", "Please contact admin!");
          console.log(error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [communityId, communityRole]);

  // if role is not admin don't show
  if (communityRole !== "admin") {
    return <></>;
  }

  if (isLoading) {
    return (
      <div className="animate-pulse h-10 w-10 flex items-center place-content-center">
        <div className="h-6 w-6 theme-bg-disable rounded" />
      </div>
    );
  }

  if (!analyticsLink) {
    return <></>;
  }
  // show link
  return (
    <PremiumFeature isAvailable={communityPac.analytics}>
      {user && community && (
        <div
          onClick={() => {
            window.open(analyticsLink, "_blank");
            mixPanel.track("open-analyticsLink", { CTAButton: "Header" });
          }}
          className="flex-row flex items-center">
          <IconButton2
            icon="chart-histogram"
            className="text-xl cursor-pointer"
          />
          <div className="sm:hidden">
            <I18>Analytics</I18>
          </div>
        </div>
      )}
    </PremiumFeature>
  );
}

const stp = (state) => ({
  user: state.auth,
  community: state.community,
  communityPac: state.communityPac,
});

export default withToast(connect(stp)(AnalyticsLinkIcon));
